export default {
  state: {
    loginStatus: false,
    user_id: '',
    mobile: '',
    user_name: '',
    qq: '',
    create_time: '',
    auth_name: '',
    auth_status: '',
    money: '',
    weixin_nickname:'',
    allow_withdrawal_money: 0,
    order_class: [],
    is_partner: '',
    partner_invite_code: '',
    partner_info: null,
    partner_id: '',
    partner_state: '',
    huaweicloud_user_info:null,
    email: '',
    auth_data:null
  },
  mutations: {
    updateUser(state,payload){
      state.user_id = payload.user_id;
      state.user_name = payload.user_name;
      state.mobile = payload.mobile;
      state.qq = payload.qq;
      state.create_time = payload.create_time;
      state.auth_name = payload.auth_name;
      state.auth_status = payload.auth_status;
      state.money = payload.money;
      state.allow_withdrawal_money = payload.allow_withdrawal_money;
      state.loginStatus = payload.loginStatus;
      state.weixin_nickname = payload.weixin_nickname;
      state.is_partner = payload.is_partner;
      state.partner_invite_code = payload.partner_invite_code;
      state.huaweicloud_user_info = payload.huaweicloud_user_info;
      state.email = payload.email;
      state.auth_data = payload.auth_data;
    },
    updateUserQq(state, payload) {
      state.qq = payload.qq;
    },
    updateUserEmail(state, payload) {
      state.email = payload.email;
    },
    updateUserWx(state) {
      state.weixin_nickname = '';
    },
    updateUserMobile(state, payload) {
      state.mobile = payload.mobile;
    },
    updateUserAuthName(state, payload) {
      state.auth_name = payload.auth_name;
    },
    updateOrderClass(state, payload){
      state.order_class = payload.order_class;
    },
    updateIsPartner(state, payload) {
      state.is_partner = payload.is_partner;
    },
    updatePartnerId(state, payload) {
      state.partner_id = payload;
    },
    updatePartnerState(state, payload) {
      state.partner_state = payload;
    },
    updatePartnerInfo(state, payload) {
      state.partner_info = payload;
    },
    resetUserInfo(state) {
      state.user_id = '';
      state.user_name = '';
      state.mobile = '';
      state.qq = '';
      state.create_time = '';
      state.auth_name = '';
      state.auth_status = '';
      state.money = '';
      state.loginStatus = '';
      state.weixin_nickname = '';
      state.email='';

    }
  },
  actions: {},
  getters: {
    getUserInfo(state){
      return state
    },
    getUserId(state){
      return state.user_id
    },
    getUserQq(state){
      return state.qq
    },
    getOrderClass(state){
      return state.order_class
    },
    getAuthName(state){
      return state.auth_name
    },
    getMobile(state){
      return state.mobile
    },
    getLoginStatus(state){
      return state.loginStatus
    },
    getUserMoney(state){
      return state.money
    },
    getIsPartner(state) {
      return state.is_partner
    },
    getInviteCode(state) {
      return state.partner_invite_code
    },
    getPartnerId(state) {
      return state.partner_id
    },
    getPartnerState(state) {
      return state.partner_state
    },
    getPartnerInfo(state) {
      return state.partner_info
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/moudles/user.js